export const CheckedBoxIcon = ({ color }: { color?: string }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1" width="22" height="22" rx="1" fill="#4794EF" />
    <rect x="1" y="1" width="22" height="22" rx="1" stroke="#4794EF" strokeWidth="2" strokeLinejoin="round" />
    <path d="M5 12.4167L11.5 17L19 6" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

